import * as yup from 'yup';
import * as z from 'zod';

export const requiredPercentTransform = (v: number) => v / 100;

export const percentTransform = (v: number | null | undefined) => {
  if (v === null) {
    return null;
  }
  if (v === undefined) {
    return undefined;
  }
  return v / 100;
};

const optionalNumberTransform = (v: number) => (Number.isNaN(v) ? undefined : v);
export const transformedNumberSchema = yup.number().transform(optionalNumberTransform);

export const transformedNonNegativeNumberSchema = transformedNumberSchema.min(0);

export const optionalStringTransform = (v: string) => (v === '' ? null : v);
export const transformedOptionalString = yup
  .string()
  .optional()
  .transform(optionalStringTransform)
  .nullable();

type OptionalStringInput =
  | z.ZodNumber
  | z.ZodOptional<z.ZodNumber>
  | z.ZodPipe<z.ZodNumber, z.ZodTransform<number, number>>
  | z.ZodPipe<
      z.ZodOptional<z.ZodNumber>,
      z.ZodTransform<number | null | undefined, number | undefined>
    >;
type OptionalStringInputWithDefault = z.ZodDefault<OptionalStringInput>;

type ZodInputStringPipe<P extends OptionalStringInput | OptionalStringInputWithDefault> = z.ZodPipe<
  z.ZodPipe<z.ZodOptional<z.ZodPipe<z.ZodString, z.ZodTransform<string | undefined, string>>>>,
  P
>;

export const zodInputStringPipe = <P extends OptionalStringInput | OptionalStringInputWithDefault>(
  zodPipe: P,
) =>
  z
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .optional()
    .refine((value) => value === undefined || !Number.isNaN(Number(value)), {
      message: 'Valid number is required',
    })
    .transform((value) => (value === undefined ? undefined : Number(value)))
    .pipe(zodPipe) as unknown as ZodInputStringPipe<P>;
